export class RequestExecutorConstants {
  public static readonly MAX_HEADERS_SIZE = 32768;
}
